import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-no-brand',
  templateUrl: './no-brand.component.html',
  styleUrls: ['./no-brand.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class NoBrandComponent {}
